import React from "react";
import { useLang } from "../context/LanguageContext";

const images = [
  { src: "/images/aula1.jpeg", alt: "We are thankful — trabajos en aula", h: "h-96" },
  { src: "/images/act1.jpeg", alt: "Actividad de motricidad con listones", h: "h-72" },
  { src: "/images/evt1.jpeg", alt: "Desfile del Día de la Independencia", h: "h-80" },
  { src: "/images/photo1.jpeg", alt: "Festejo patrio en el colegio", h: "h-96" },
  { src: "/images/evt2.jpeg", alt: "Visita educativa al museo", h: "h-72" },
  { src: "/images/aula4.jpeg", alt: "Clase de arte y pintura en aula", h: "h-80" },
  { src: "/images/evt3.jpeg", alt: "Manualidad mexicana — cactus con sombrero", h: "h-96" },
  { src: "/images/act5.jpeg", alt: "Actividad acuática en inflables", h: "h-72" },
  { src: "/images/act2.jpeg", alt: "Desfile cívico — Leyes de Reforma", h: "h-80" },
  { src: "/images/evt4.jpeg", alt: "Pintando la bandera de México", h: "h-96" },
  { src: "/images/photo3.jpeg", alt: "Celebración Día de Muertos", h: "h-72" },
  { src: "/images/aula2.jpeg", alt: "Figuras geométricas y lógica en aula", h: "h-80" },
  { src: "/images/evt5.jpeg", alt: "Show escolar con botargas", h: "h-96" },
  { src: "/images/act3.jpeg", alt: "Convivencia deportiva con papás", h: "h-72" },
  { src: "/images/aula3.jpeg", alt: "Actividad sensorial en aula", h: "h-80" },
  { src: "/images/act4.jpeg", alt: "¡Felicidades! — festejo escolar", h: "h-72" },
  { src: "/images/aula5.jpeg", alt: "Actividad con bloques de construcción en aula", h: "h-80" },
  { src: "/images/photo2.jpeg", alt: "Actividad deportiva en el patio", h: "h-80" },
];

const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="galeria" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12">
          <div className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#E63946] mb-4">
            {t.gallery.overline}
          </div>
          <h2 className="font-fredoka text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] text-[#1D3557]">
            {t.gallery.title}
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6 [column-fill:_balance]">
          {images.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-image-${i}`}
              className={`mb-4 md:mb-6 break-inside-avoid rounded-[1.75rem] overflow-hidden group relative border border-[#E2E8F0]/70`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className={`w-full ${img.h} object-cover transition-transform duration-500 group-hover:scale-105`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
